import { render, staticRenderFns } from "./ButtonDisplayMode.vue?vue&type=template&id=5019db90&scoped=true&"
import script from "./ButtonDisplayMode.vue?vue&type=script&lang=js&"
export * from "./ButtonDisplayMode.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDisplayMode.vue?vue&type=style&index=0&id=5019db90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019db90",
  null
  
)

export default component.exports